import { type DocumentVariableMetadata, documentVariable } from './document-variable'

/**
 * Los metadatos SUELTOS: proyecto, sociedad, propietario, asesor, documento y otros.
 *
 * Espeja `shared/variables/domains/misc.variables.ts`, que ahora los referencia y aporta el
 * `resolve` de cada uno. Un archivo por dominio, igual que allá: el criterio para partirlos es el
 * mismo que ya tenía el catálogo, y hacerlos coincidir uno a uno es lo que permite leer los dos
 * lados en paralelo.
 */

// 🏢 Proyecto
export const PROJECT_VARIABLE_METADATA: DocumentVariableMetadata[] = [
  documentVariable({
    key: 'nombre_proyecto',
    label: 'Nombre del Proyecto',
    category: 'project',
    type: 'string',
    example: 'Residencial Vista Hermosa'
  }),
  documentVariable({
    key: 'codigo_proyecto',
    label: 'Código del Proyecto',
    category: 'project',
    type: 'string',
    example: 'VH-2024-001'
  })
]

// 👤 Sociedad
export const SOCIETY_VARIABLE_METADATA: DocumentVariableMetadata[] = [
  documentVariable({
    key: 'nombre_sociedad',
    label: 'Nombre de la Sociedad',
    category: 'society',
    type: 'string',
    example: 'Desarrollos Inmobiliarios San José S.A.'
  })
]

// 👥 Propietario (datos ya derivados en ctx.owner por el orquestador)
export const OWNER_VARIABLE_METADATA: DocumentVariableMetadata[] = [
  documentVariable({
    key: 'nombre_propietario',
    label: 'Nombre del Propietario',
    category: 'owner',
    type: 'string'
  }),
  documentVariable({
    key: 'nit_propietario',
    label: 'NIT del Propietario',
    category: 'owner',
    type: 'string'
  }),
  documentVariable({
    key: 'email_propietario',
    label: 'Email del Propietario',
    category: 'owner',
    type: 'string'
  }),
  documentVariable({
    key: 'telefono_propietario',
    label: 'Teléfono del Propietario',
    category: 'owner',
    type: 'string'
  }),
  documentVariable({
    key: 'nombre_representante_legal',
    label: 'Nombre del Representante Legal',
    category: 'owner',
    type: 'string'
  }),
  documentVariable({
    key: 'nit_representante_legal',
    label: 'NIT del Representante Legal',
    category: 'owner',
    type: 'string'
  }),
  documentVariable({
    key: 'email_representante_legal',
    label: 'Email del Representante Legal',
    category: 'owner',
    type: 'string'
  }),
  documentVariable({
    key: 'telefono_representante_legal',
    label: 'Teléfono del Representante Legal',
    category: 'owner',
    type: 'string'
  }),
  documentVariable({
    key: 'nombre_propietario_representante_legal',
    label: 'Propietario/Representante Legal',
    category: 'owner',
    type: 'string',
    description: 'Nombre del propietario (individual) o representante legal (jurídica)'
  })
]

// 👨‍💼 Asesor
export const ADVISOR_VARIABLE_METADATA: DocumentVariableMetadata[] = [
  documentVariable({
    key: 'nombre_asesor',
    label: 'Nombre del Asesor',
    category: 'advisor',
    type: 'string'
  })
]

// 📄 Documento
export const DOCUMENT_VARIABLE_METADATA: DocumentVariableMetadata[] = [
  documentVariable({
    key: 'fecha_impresion',
    label: 'Fecha de Impresión',
    category: 'document',
    type: 'date'
  })
]

// 🔄 Otros
export const OTHER_VARIABLE_METADATA: DocumentVariableMetadata[] = [
  documentVariable({
    key: 'fecha_de_hoy',
    label: 'Fecha de Hoy',
    category: 'other',
    type: 'date',
    description: 'Fecha actual dd/MM/yyyy'
  }),
  documentVariable({
    key: 'hora_actual',
    label: 'Hora Actual',
    category: 'other',
    type: 'string',
    description: 'Hora actual HH:mm:ss'
  })
]
